import Cookie from '@wetransfer/concorde-cookie';
import Browser from '@wetransfer/concorde-browser';

import Config from '@app/config';
import Helper from '@app/helper';
import Store from '@app/store';

// Write cookie with date and amount of transfers sent.
function writeCookie() {
  const now = new Date();
  const formatted = `${now.getMonth() +
    1}/${now.getDate()}/${now.getFullYear()}`;
  const sent = Helper.getWTSent();
  const cookieValue = [formatted, sent].join(',');
  Cookie.set(Config.cookies.takeover.name, cookieValue, { days: 365 });
}

function readCookie() {
  let cookie = Cookie.get(Config.cookies.takeover.name);
  if (!cookie) {
    return false;
  }

  // Examine cookie
  cookie = cookie.split(',');
  const [date, filesSent] = cookie;
  if (!date || !filesSent) {
    return false;
  }
  const sent = parseInt(filesSent || 0, 10);

  return { date, sent };
}

function hasValidCookie() {
  const previously = readCookie();
  if (!previously) {
    return false;
  }

  // When was this set?
  const daysSince = Helper.getDaysBetweenDates(previously.date, new Date());

  // Check if daysSince is a number
  if (isNaN(daysSince)) {
    return false;
  }

  // How many transfers have been sent?
  const sent = Helper.getWTSent();
  // How many transfers have been done since?
  const sentSince = sent - previously.sent;

  // Don't show if less than 7 days have expired and less than 20 transfers have been done
  if (daysSince < 7 && sentSince < 20) {
    return true;
  }

  return false;
}

// This diagram is out of date. But we can keep it for future reference when we refactor this page.
// https://code2flow.com/D0hxyC : contains all the logic to show/not show the Splashpage (out of date)
function shouldDisplaySplashpage() {
  const isVisitingFirstTime = Helper.getFirstVisitDate() === undefined;
  if (isVisitingFirstTime) {
    return false;
  }

  if (Browser.isMobile || window.innerWidth <= 950) {
    return false;
  }

  const { route, user, channel } = Store.getState();

  // Only on the upload page (this catches both download/:id and /wallpaper/:id) and panel open
  if (route.type !== 'transfer' || route.params.id) {
    return false;
  }

  // Not in IE9 or lower
  if (Browser.matches('explorer <= 9.0')) {
    return false;
  }

  // Not for logged in users.
  const plusCookie = parseInt(Cookie.get('wt_plus'), 10) === 1;
  if (user.loggedIn || plusCookie) {
    return false;
  }

  // Not when T&C are not accepted
  if (!Cookie.get('wt_tandc')) {
    return false;
  }

  // Don't show on channels
  if (channel && channel.name) {
    return false;
  }

  // Verify existing cookie (if any)
  if (hasValidCookie()) {
    return false;
  }

  return true;
}

export default {
  shouldDisplaySplashpage,
  writeCookie,
};
